import { Observable } from 'rxjs';
import { EntityExData } from '../../lib/entity/entity.model';

/**
 * Abstract provider for Entity operations.
 * Each application (portal/my) must provide its own implementation.
 */
export abstract class EntityProvider {
  abstract getEntity$(companyId: number): Observable<EntityExData>;
  abstract getEntities$(): Observable<EntityExData[]>;
}
